export const roundCubicCapacity = (value: number) => (Math.round(value / 100) / 10).toFixed(1);
